import ProductTypesOptionsConstants from "@/constants/sale/productTypesOptions.constants";

export default Object.freeze({
  api: {
    url: import.meta.env.VITE_MENUUS_API_URL,

    integrator: {
      login: import.meta.env.PEDEAI_INTEGRATOR_USERNAME,
      password: import.meta.env.PEDEAI_INTEGRATOR_PASSWORD,
    },
    pointOfSale: {
      id: import.meta.env.VITE_PEDEAI_POINT_OF_SALE_ID,
    },
  },
  productTypeOption: {
    [ProductTypesOptionsConstants.PEDEAI]: import.meta.env
      .VITE_PEDEAI_PRODUCT_TYPE_ID,
  },
  partner: {
    pedeai: {
      availableProducts: {
        [ProductTypesOptionsConstants.PEDEAI_APP]: String(
          import.meta.env.VITE_PEDEAI_PARTNER_PEDEAI_AVAILABLE_PRODUCTS,
        ),
      },
    },
  },
});
